export default "__VITE_ASSET__JjMtgwgU__"